var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAngleLeft = function SvgAngleLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.3258 6.17417C24.5936 5.44194 23.4064 5.44194 22.6742 6.17417L12.1742 16.6742C11.4419 17.4064 11.4419 18.5936 12.1742 19.3258L22.6742 29.8258C23.4064 30.5581 24.5936 30.5581 25.3258 29.8258C26.0581 29.0936 26.0581 27.9064 25.3258 27.1742L16.1516 18L25.3258 8.82583C26.0581 8.09359 26.0581 6.90641 25.3258 6.17417Z",
    fill: "#818181"
  })));
};
export default SvgAngleLeft;